import React from "react";

function DisabledIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5H4.16667H17.5"
        stroke="#FF0000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8333 5.00002V16.6667C15.8333 17.1087 15.6577 17.5326 15.3451 17.8452C15.0326 18.1578 14.6087 18.3334 14.1666 18.3334H5.83329C5.39127 18.3334 4.96734 18.1578 4.65478 17.8452C4.34222 17.5326 4.16663 17.1087 4.16663 16.6667V5.00002M6.66663 5.00002V3.33335C6.66663 2.89133 6.84222 2.4674 7.15478 2.15484C7.46734 1.84228 7.89127 1.66669 8.33329 1.66669H11.6666C12.1087 1.66669 12.5326 1.84228 12.8451 2.15484C13.1577 2.4674 13.3333 2.89133 13.3333 3.33335V5.00002"
        stroke="#FF0000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33337 9.16669V14.1667"
        stroke="#FF0000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6666 9.16669V14.1667"
        stroke="#FF0000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DisabledIcon;
